import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    margin: theme.spacing(10, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 16),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 10, 0, 17),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 12),
    },
  },
  accordionWrapper: {
    marginBottom: theme.spacing(12.5),
  },
  priceHeader: {
    width: '100%',
  },
  primaryHeading: {
    marginBottom: theme.spacing(1),
  },
  priceListContainer: {
    padding: theme.spacing(5),
    background: theme.palette.background.grey,
    [theme.breakpoints.up('lg')]: {
      lineHeight: 1.67,
    },
  },
  accordionDetails: {
    flexDirection: 'column',
  },
}))
